<div class="modal-container main-font">
  <div class="modal-content-container">
    <div class="header-container">
      <p class="title-modal mb-0">Seleziona la tipologia di giornata</p>
      <p class="modal-description mb-0">Definisci la modalità lavorativa</p>
    </div>
    <form [formGroup]="formDay" class="w-100 d-flex flex-column gap-4">
      <div class="info-container">
        <div class="date-container">
          <img
            src="assets/images/icon_calendar/calenda.svg"
            alt=""
            class="icon-calendar" />
          <p class="mb-0 text-date">{{ formatDateItalian(date) }}</p>
        </div>
        <label nz-radio formControlName="regular">
          <p class="mb-0 text-label">Giornata Ordinaria</p>
        </label>
      </div>
      <div class="select-container">
        <p class="mb-0 text-label">Posti in azienda</p>
        <input nz-input type="number" formControlName="limit" />
      </div>

      <nz-radio-group
        class="d-flex flex-column gap-4"
        formControlName="day_type">
        <label nz-radio [nzValue]="1">
          <p class="mb-0 text-label">Day Off</p>
        </label>

        <label nz-radio [nzValue]="2">
          <p class="mb-0 text-label">Lavoro da remoto</p>
        </label>

        <label nz-radio [nzValue]="14">
          <p class="mb-0 text-label">Presenza obbligatoria</p>
        </label>

        <label nz-radio nzValue="hybrid-day">
          <p class="mb-0 text-label">Giornata ibrida</p>
        </label>
      </nz-radio-group>
      <div
        class="d-flex flex-column w-50 gap-1"
        *ngIf="this.formDay.contains('hybridOption')">
        <p class="mb-0 text-label">Tipologia</p>
        <nz-select class="w-100" formControlName="hybridOption">
          <nz-option [nzValue]="3" nzLabel="Remoto al mattino"></nz-option>
          <nz-option [nzValue]="4" nzLabel="Remoto al pomeriggio"></nz-option>
        </nz-select>
      </div>
    </form>
  </div>
  <div class="buttons-container">
    <button class="secondary-btn w-100" (click)="closeModal()">Annulla</button>
    <button
      class="w-100"
      [ngClass]="!isButtonEnabled() ? 'disabled-btn' : 'primary-btn'"
      [disabled]="!isButtonEnabled()"
      (click)="save()">
      Salva
    </button>
  </div>
</div>
